import React from 'react'
import styled from 'styled-components'
// @ts-ignore
import { sys } from '@netbasequid/theme'
import { useDisplayTheme } from 'hooks/useUiState'

const Line = styled.div<{ mode: string } & DividerProps>`
  background: ${({ mode }) => sys[mode].common.divider[100]};
  width: ${({ width }) => width || '1px'};
  height: ${({ height }) => height || '1px'};
`

type DividerProps = {
  className?: string
  width?: string
  height?: string
}

const Divider = ({ className, width, height }: DividerProps) => {
  const displayTheme = useDisplayTheme()
  return <Line className={className} mode={displayTheme} width={width} height={height} />
}

export default Divider
